<template>
  <main class="mx-8">
    <trac-loading class="" v-if="isLoading" />
    <trac-modal v-if="confirmOp" @close="confirmOp = false">
      <h3 class="text-lg font-semibold p-2 text-primaryBlue">Kindly Confirm</h3>
      <div class="my-10 px-20 flex items-center justify-center text-center">
        <p class="text-sm font-semibold">Are you sure you want to delete {{ user.first_name + ' ' + user.last_name }}?
        </p>
      </div>
      <div class="flex justify-around text-xs">
        <button @click="confirmOp = false"
        class="border py-2 px-5 rounded-md text-primaryBlue border-primaryBlue">Cancel</button>
        <button @click="updateOps('deleted')"
        class="capitalize border py-2 px-5 rounded-md text-red-600 border-red-600">Delete</button>
      </div>
    </trac-modal>

    <trac-back-button>
      <h2 class="text-xs">Settings</h2>
    </trac-back-button>
    <div class="flex justify-between items-center">
      <h1 class="font-medium mt-2">Employee Details</h1>
      <div class="flex gap-4">
        <button
        @click="updateOps(user.active ? 'deactivated' : 'active')"
          class="border border-primaryBlue text-primaryBlue font-semibold py-2 px-4 rounded text-xs smallest uppercase">
          {{ user.active ? 'Deactivate' : 'Activate' }} {{ user.first_name }}
        </button>
        <button @click="confirmOp = true" class="border border-primaryBlue text-primaryBlue font-semibold py-2 px-4 rounded text-xs smallest">
          DELETE
        </button>
      </div>
    </div>
    <div class="flex mt-6">
      <div class="shadow p-8 rounded-md bg-white w-full relative flex gap-10">
        <div @click="sendtoEmployee" class="absolute right-0 mt-3 mr-6 flex items-center cursor-pointer">
          <svg width="20" height="20" viewBox="0 0 20 20" class="" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.94118 2.87109H2.76471C1.79009 2.87109 1 3.66118 1 4.6358V16.9887C1 17.9634 1.79009 18.7534 2.76471 18.7534H15.1176C16.0923 18.7534 16.8824 17.9634 16.8824 16.9887V10.8123"
              stroke="#013E9E" stroke-linecap="round" stroke-linejoin="round" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.5587 1.54822C16.2896 0.817259 17.4747 0.817259 18.2057 1.54822C18.9367 2.27919 18.9367 3.46432 18.2057 4.19528L9.82336 12.5776L6.29395 13.46L7.1763 9.93058L15.5587 1.54822Z"
              stroke="#013E9E" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <p class="text-primaryBlue text-xs ml-2">Edit</p>
        </div>
        <div class="flex justify-center items-center flex-col">
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none"
            stroke="#909090" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5.52 19c.64-2.2 1.84-3 3.22-3h6.52c1.38 0 2.58.8 3.22 3" />
            <circle cx="12" cy="10" r="3" />
            <circle cx="12" cy="12" r="10" />
          </svg>
          <p class="font-bold">{{ user.first_name }} {{ user.last_name }}</p>
        </div>
        <div class="grid grid-cols-2 gap-3 ml-0">
          <div>
            <p class="text-gray-500 text-sm">Email</p>
            <p class="text-xs font-bold">{{ user.email }}</p>
          </div>
          <div class=""></div>
          <div>
            <p class="text-gray-500 text-sm">Phone</p>
            <p class="text-xs font-bold">{{ user.phone }}</p>
          </div>
          <div>
            <p class="text-gray-500 text-sm">Status</p>
            <p class="text-xs font-bold">{{ user.active ? 'Active' : 'Inactive' }}</p>
          </div>
          <!-- <div>
            <p class="text-gray-500 text-sm">Location</p>
            <p class="text-xs">{{  }}</p>
          </div> -->
        </div>
      </div>
      <div class="ml-4 shadow p-4 rounded-md bg-white w-full flex">
        <div class="w-full pt-5">
          <p class="text-gray-500 text-xs pb-3">Assigned Stores({{ user.stores.length }})</p>
          <div class="overflow-y-scroll h-32">
            <p class="text-xs py-1 capitalize font-semibold" v-for="(store, index) in user.stores" :key="index">{{
                store.name
            }}</p>
          </div>
        </div>
        <div class="w-full flex flex-col p-4 gap-5 justify-between items-stretch border-l">
          <div>
            <p class="text-gray-500 text-xs">Total Sales:</p>
            <p class="font-normal text-2xl" v-if="userSaleSummaryDetails">{{ userSaleSummaryDetails.allTimeTotal |
                formatPrice
            }}</p>
            <p class="font-semibold text-sm" v-else>{{ noUserSaleSummaryDetails ? 'No Data' : 'Loading...' }}</p>
          </div>
          <hr>
          <div>
            <p class="text-gray-500 text-xs">Today’s Sales</p>
            <p class="font-normal text-2xl" v-if="userSaleSummaryDetails">{{ userSaleSummaryDetails.todayTotal |
                formatPrice
            }}</p>
            <p class="font-semibold text-sm" v-else>{{ noUserSaleSummaryDetails ? 'No Data' : 'Loading...' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="shadow-2xl p-4 rounded md:mt-10">
      <div class="mt-4 pr-4 md:pr-0">
        <main id="table">
          <div class="">
            <div class="grid md:flex md:justify-between w-full items-center">
              <div class="relative max-w-sm rounded-md w-full flex items-center">
                <input type="text" placeholder="Search customer name or receipt number" class="
                    input-shadow
                    py-2
                    w-full
                    pl-5
                    text-xs
                    focus:outline-none
                    leading-7
                    tracking-wide
                    text-primaryGray
                  " v-model="search" />
                <svg class="w-4 h-4 absolute right-0 mr-6" viewBox="0 0 14 14" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="6.56705" cy="6.61686" r="5.39909" stroke="#253B95" stroke-width="1.06786"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M13.3156 13.3659L10.3799 10.4302" stroke="#253B95" stroke-width="1.06786"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="flex">
                <div class="flex items-center gap-0 md:ml-5">
                  <div class="text-xs hidden md:block"></div>
                  <div class="w-full">
                    <div @click="paymentStore = !paymentStore" v-click-outside="paymentDrop" class="
                        border
                        smallest
                        text-primaryBlue
                        focus:outline-none
                        border-primaryBlue
                        py-2
                        px-4
                        rounded
                        inline-flex
                        md:w-32
                        justify-between
                        capitalize
                        items-center
                        cursor-pointer
                        w-full
                        mb-2
                        md:mb-0 md:mt-0
                      ">
                      <div class="
                          h-full
                          w-full
                          flex
                          items-center
                          justify-between
                          whitespace-no-wrap
                        ">
                        Select Store
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                      </div>
                    </div>
                    <div v-if="paymentStore" @click.stop class="
                        h-48
                        max-w-lg
                        overflow-y-auto
                        border
                        items-center
                        mt-2
                        ring
                        w-full
                        gap-5
                        py-2
                        absolute
                        grid grid-cols-3
                        z-50
                        rounded-md
                        shadow-lg
                        bg-white
                        ring-1 ring-black ring-opacity-5
                        right-0
                      ">
                      <div class="
                          flex
                          items-center
                          cursor-pointer
                          capitalize
                          text-xs
                        ">
                        <input v-model="paymentAll" type="checkbox" class="ml-4" @input="filterFlag = 'store'" />
                        <div class="ml-3">All</div>
                      </div>
                      <div role="menu" aria-orientation="vertical" aria-labelledby="options-menu"
                        v-for="(store, index) in getAllCsv" :key="index">
                        <div class="
                            block
                            px-4
                            text-sm text-gray-700
                            hover:bg-gray-100 hover:text-gray-900
                          " role="menuitem">
                          <div class="
                              flex
                              items-center
                              cursor-pointer
                              capitalize
                              text-xs
                            ">
                            <input :value="store._id" v-model="selectedStores" type="checkbox" class="mr-3"
                              @input="filterFlag = 'store'" />
                            {{ store.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="md:ml-4 relative">
                    <button @click="active = !active" v-click-outside="dismissdateFilterDropdown" id="options-menu"
                      aria-haspopup="true" aria-expanded="true" type="button" class="
                        whitespace-no-wrap
                        border
                        smallest
                        text-primaryBlue
                        focus:outline-none
                        border-primaryBlue
                        py-2
                        px-4
                        rounded
                        inline-flex
                        md:w-32
                        justify-between
                        capitalize
                        items-center
                        w-full
                        mt-2
                        mb-4
                        md:mt-0 md:mb-0
                      ">
                      Filter by date
                      <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </button>
                    <div v-show="active" @click="active = false" class="
                        absolute
                        white-gradient
                        px-4
                        py-6
                        bg-white
                        mt-1
                        rounded-md
                        w-screen
                        md:w-128
                        right-0
                      " style="">
                      <div class="flex w-full justify-between">
                        <div class="w-full ml-8">
                          <p class="text-xs font-medium">By Date</p>
                          <div class="mt-2 flex items-center">
                            <input type="radio" v-model="time" value="today" name="" id="" />
                            <p class="text-xs ml-3 leading-7">Today</p>
                          </div>
                          <div class="mt-2 flex items-center">
                            <input type="radio" value="currentMonth" v-model="time" name="" id="" />
                            <p class="text-xs ml-3 leading-7">This Month</p>
                          </div>
                          <div class="mt-2 flex items-center">
                            <input type="radio" name="" value="lastMonth" v-model="time" id="" />
                            <p class="text-xs ml-3 leading-7">Last Month</p>
                          </div>
                          <div @click.stop="toggle = !toggle" class="mt-2 flex relative items-center">
                            <svg class="w-3 h-3" :class="{
                              'fill-current text-blue-500': time == 'custom',
                            }" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="0.975586" y="2.43408" width="12.7281" height="12.2995" rx="1.65333"
                                stroke="#253B95" stroke-width="1.23999" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path d="M10.168 1.06738V3.8006" stroke="#253B95" stroke-width="1.23999"
                                stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M4.51079 1.06738V3.8006" stroke="#253B95" stroke-width="1.23999"
                                stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M0.975586 6.53404H13.7037" stroke="#253B95" stroke-width="1.23999"
                                stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <p @click="open = !open" class="
                                text-xs
                                ml-3
                                leading-7
                                text-primaryBlue
                                cursor-pointer
                              ">
                              Select Date
                            </p>
                            <div class="relative">
                              <date-picker ref="datepicker" v-model="custom" :inline="true" v-if="open"
                                @change="handleChange" format="YYYY-MM-DD" class="absolute shadow-md curr" range>
                              </date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="border-l pl-8 w-full">
                          <p class="text-xs font-medium">By Status</p>
                          <div class="mt-2 flex items-center">
                            <input type="radio" name="" v-model="time" value="pending" id="" />
                            <p class="text-xs ml-3 leading-7">Pending</p>
                          </div>
                          <div class="mt-2 flex items-center">
                            <input type="radio" v-model="time" value="paid" name="" id="" />
                            <p class="text-xs ml-3 leading-7">Paid</p>
                          </div>
                          <div class="mt-2 flex items-center">
                            <input v-model="time" value="failed" type="radio" name="" id="" />
                            <p class="text-xs ml-3 leading-7">Failed</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex">
                  <div class="items-end justify-end w-full hidden md:flex">
                    <div class="md:ml-4 w-full">
                      <div @click="paymentDropdownData = !paymentDropdownData" v-click-outside="dismissPaymentDropdown"
                        class="
                        border
                        smallest
                        text-primaryBlue
                        focus:outline-none
                        border-primaryBlue
                        py-2
                        px-3
                        rounded
                        inline-flex
                        justify-between
                        capitalize
                        items-center
                        cursor-pointer
                        w-full
                        mb-2
                        md:mb-0 md:mt-0
                      ">
                        <div class="
                          h-full
                          w-full
                          flex
                          items-center
                          justify-between
                          whitespace-no-wrap
                        ">
                          Filter by Payment
                          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                          </svg>
                        </div>
                      </div>
                      <div class="bg-white absolute border right-0 rounded-lg mt-2" v-if="paymentDropdownData">
                        <div @click.stop class="
                          grid grid-cols-3
                          max-w-lg
                          overflow-y-auto
                          items-center
                          mt-2
                          ring
                          w-full
                          gap-5
                          py-2
                          z-50
                          bg-white
                          ring-1 ring-black ring-opacity-5
                        ">
                          <div class="
                            flex
                            items-center
                            cursor-pointer
                            capitalize
                            text-xs
                          ">
                            <input v-model="allPaymentMethods" id="all-employees" type="checkbox" class="ml-4"
                              @input="filterFlag = 'payment'" />
                            <label class="ml-3 cursor-pointer" for="all-employees">All</label>
                          </div>
                          <div role="menu" aria-orientation="vertical" aria-labelledby="options-menu"
                            v-for="(paymentMethod, index) in paymentMethods" :key="index">
                            <div class="
                              block
                              px-4
                              text-sm text-gray-700
                              hover:bg-gray-100 hover:text-gray-900
                            " role="menuitem">
                              <div class="
                                flex
                                items-center
                                cursor-pointer
                                capitalize
                                text-xs
                              ">
                                <input :value="paymentMethod._id" v-model="selectedPaymentMethods" type="checkbox"
                                  :id="'payment-method-' + index" class="mr-3" @input="filterFlag = 'payment'" />
                                <label class="cursor-pointer" :for="'payment-method-' + index">{{ paymentMethod.name
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      <div class="mb-8 mt-4 overflow-scroll p-2">
        <div class="overflow-scroll">
          <table class="w-full table-auto">
            <thead class="bg-blue-100">
              <tr class="min-h-16 rounded-tl-sm">
                <th class="text-xs">
                  <p class="whitespace-nowrap p-6 text-center">Date</p>
                </th>
                <th class="text-xs">
                  <p class="whitespace-nowrap p-6 text-center">Customer</p>
                </th>
                <th class="text-xs">
                  <p class="whitespace-nowrap p-6 text-center">Receipt No</p>
                </th>
                <th class="text-xs">
                  <p class="whitespace-nowrap p-6 text-center">
                    Transaction Type
                  </p>
                </th>
                <th class="text-xs">
                  <p class="whitespace-nowrap p-6 text-center">No Of Items</p>
                </th>
                <th class="text-xs">
                  <p class="whitespace-nowrap p-6 text-center">Sales Amount</p>
                </th>
                <th class="text-xs">
                  <p class="whitespace-nowrap p-6 text-center">
                    Payment Method
                  </p>
                </th>
                <th class="text-xs">
                  <p class="whitespace-nowrap p-6 text-center">Sold By</p>
                </th>
              </tr>
            </thead>
            <tbody v-if="!allEmployeeSales">
              <tr>
                <td class="text-xs font-medium p-4" colspan="7">
                  <trac-center-data>
                    <div class="h-40 flex items-center text-lg text-gray-600">
                      Loading Data...
                    </div>
                  </trac-center-data>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="allEmployeeSales.length > 0">
              <tr @click="
                $router.push({
                  name: 'SalesDetails',
                  params: {
                    id: payment._id || payment.offline_sale_id,
                  },
                })
              " v-for="(payment, i) in search.length > 0
? allHistory
: sortbyOtherFilterMethods" :key="i">
                <td class="text-center py-4 text-xs capitalize text-accentDark">
                  <div class="
                        w-full
                        items-center
                        py-5
                        pl-8
                        text-xs text-accentDark
                        font-normal
                        grid
                      ">
                    {{
                        moment(payment.created_at || payment.offline_date).format(
                          "Do-MMM-YYYY"
                        )
                    }}
                    <div class="">
                      <span class="text-red-900 bg-red-300 p-1 rounded" style="font-size: 0.4rem"
                        v-if="payment.isNotSyncedSale1">not synced</span>
                    </div>
                  </div>
                </td>
                <td class="text-center py-4 text-xs capitalize text-accentDark font-extrabold">
                  {{ payment.customer_name || "N/A" }}
                </td>
                <td class="text-center py-4 text-xs capitalize text-accentDark">
                  {{ payment.receipt_number || "N/A" }}
                </td>
                <td class="text-center py-4 text-xs capitalize text-accentDark">
                  {{ payment.transaction_type }}
                </td>
                <td class="text-center py-4 text-xs capitalize text-accentDark">
                  {{ (payment.items || []).length }} Item(s)
                </td>
                <td class="text-center py-4 text-xs capitalize text-accentDark">
                  {{ payment.total_price | formatPrice }}
                </td>
                <td class="text-center py-4 text-xs capitalize text-accentDark">
                  <div class="w-full py-5 pl-8 text-xs font-normal pr-10">
                    <div class="flex items-center justify-center capitalize">
                      <svg class="w-4 h-4 mr-3" v-if="payment.payment_method == 'online'" viewBox="0 0 16 16"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7" stroke="#253B95" stroke-width="0.9" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M1 8.00039H15" stroke="#253B95" stroke-width="0.9" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8 1C9.7509 2.91685 10.7459 5.40442 10.8 8C10.7459 10.5956 9.7509 13.0832 8 15C6.2491 13.0832 5.25407 10.5956 5.2 8C5.25407 5.40442 6.2491 2.91685 8 1V1Z"
                          stroke="#253B95" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <svg class="w-4 h-4 mr-3" v-if="payment.payment_method == 'invoice'" viewBox="0 0 16 18"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.125 1.35547C9.2857 1.35547 9.44002 1.41836 9.55494 1.53069L14 5.87545H9.125V1.35547Z"
                          fill="#B2E7FF" stroke="#B2E7FF" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.125 1H2.625C1.72754 1 1 1.72754 1 2.625V15.625C1 16.5225 1.72754 17.25 2.625 17.25H12.375C13.2725 17.25 14 16.5225 14 15.625V5.875L9.125 1Z"
                          stroke="#253B95" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.125 1V5.875H14" stroke="#253B95" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.75 13.1875H4.25" stroke="#253B95" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.75 10.4014H4.25" stroke="#253B95" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M3.85785 6.48881V4.45498C3.85785 4.18801 4.21497 4.09878 4.34054 4.33438L5.1832 5.91545C5.30876 6.15105 5.66588 6.06208 5.66588 5.79511C5.66588 5.13832 5.66588 4.28959 5.66588 3.63431"
                          stroke="#253B95" stroke-width="0.5" />
                        <rect x="3.08707" y="5.46582" width="3.48214" height="0.348214" fill="#253B95" />
                        <rect x="3.08707" y="4.66309" width="3.48214" height="0.348214" fill="#253B95" />
                      </svg>
                      <svg class="w-4 h-4 mr-3" v-if="
                        payment.payment_method == 'pos' ||
                        payment.payment_method == 'own_bank_account'
                      " viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M14.0035 1.01171C13.9186 0.988935 13.8244 0.998726 13.7406 1.04688L6.37332 5.30036C6.28943 5.34879 6.23321 5.426 6.21032 5.51141C6.19031 5.58602 6.19547 5.66779 6.22943 5.74299C6.23402 5.754 6.23937 5.76484 6.2455 5.77542L8.98409 10.5188C9.03212 10.6019 9.10936 10.6578 9.19514 10.6807C9.28027 10.7035 9.37481 10.6936 9.45807 10.6455L16.8253 6.39205C16.9093 6.34356 16.9654 6.26633 16.9883 6.181C17.0083 6.10631 17.0031 6.0244 16.9691 5.9492C16.9646 5.93826 16.9592 5.92751 16.9531 5.91698L14.2148 1.1741L14.2146 1.1736C14.1665 1.0905 14.0893 1.03465 14.0035 1.01171ZM9.36083 10.063L6.82817 5.67636L13.8378 1.62935L16.3705 6.01603L9.36083 10.063Z"
                          fill="#253B95" />
                        <path
                          d="M13.7406 1.04688L13.616 0.830114L13.6156 0.830377L13.7406 1.04688ZM14.0035 1.01171L13.9387 1.25316L13.9389 1.25323L14.0035 1.01171ZM6.37332 5.30036L6.24832 5.08385L6.24832 5.08386L6.37332 5.30036ZM6.21032 5.51141L6.45179 5.57617L6.4518 5.57612L6.21032 5.51141ZM6.22943 5.74299L6.46029 5.64676L6.45728 5.6401L6.22943 5.74299ZM6.2455 5.77542L6.46201 5.65042L6.46185 5.65015L6.2455 5.77542ZM8.98409 10.5188L8.76758 10.6438L8.7676 10.6438L8.98409 10.5188ZM9.19514 10.6807L9.25987 10.4392L9.25973 10.4392L9.19514 10.6807ZM9.45807 10.6455L9.58307 10.862L9.58307 10.862L9.45807 10.6455ZM16.8253 6.39205L16.7003 6.17553L16.7003 6.17554L16.8253 6.39205ZM16.9883 6.181L16.7468 6.11626L16.7468 6.11626L16.9883 6.181ZM16.9691 5.9492L16.7383 6.04546L16.7414 6.05228L16.9691 5.9492ZM16.9531 5.91698L16.7366 6.04198L16.7368 6.04222L16.9531 5.91698ZM14.2148 1.1741L13.9934 1.29058L13.9983 1.2991L14.2148 1.1741ZM14.2146 1.1736L14.436 1.05712L14.431 1.04848L14.2146 1.1736ZM6.82817 5.67636L6.70317 5.45986L6.48666 5.58486L6.61166 5.80137L6.82817 5.67636ZM9.36083 10.063L9.14433 10.188L9.26933 10.4045L9.48583 10.2795L9.36083 10.063ZM13.8378 1.62935L14.0543 1.50435L13.9293 1.28785L13.7128 1.41285L13.8378 1.62935ZM16.3705 6.01603L16.4955 6.23254L16.712 6.10754L16.587 5.89103L16.3705 6.01603ZM13.8651 1.26365C13.8902 1.24924 13.9162 1.24712 13.9387 1.25316L14.0683 0.770248C13.9211 0.730749 13.7586 0.748209 13.616 0.830114L13.8651 1.26365ZM6.49832 5.51687L13.8656 1.26339L13.6156 0.830377L6.24832 5.08385L6.49832 5.51687ZM6.4518 5.57612C6.45793 5.55324 6.47319 5.53137 6.49832 5.51686L6.24832 5.08386C6.10567 5.16621 6.00849 5.29875 5.96884 5.4467L6.4518 5.57612ZM6.45728 5.6401C6.44763 5.61873 6.44639 5.5963 6.45179 5.57617L5.96886 5.44664C5.93423 5.57575 5.94331 5.71684 6.00159 5.84589L6.45728 5.6401ZM6.46185 5.65015C6.46121 5.64904 6.46066 5.64793 6.46019 5.6468L5.99868 5.83919C6.00739 5.86007 6.01753 5.88063 6.02915 5.9007L6.46185 5.65015ZM9.20059 10.3938L6.46201 5.65042L6.02899 5.90042L8.76758 10.6438L9.20059 10.3938ZM9.25973 10.4392C9.23547 10.4327 9.21412 10.4172 9.20057 10.3937L8.7676 10.6438C8.85011 10.7867 8.98325 10.8828 9.13054 10.9222L9.25973 10.4392ZM9.33307 10.429C9.30887 10.443 9.28279 10.4454 9.25987 10.4392L9.1304 10.9222C9.27776 10.9617 9.44076 10.9442 9.58307 10.862L9.33307 10.429ZM16.7003 6.17554L9.33307 10.429L9.58307 10.862L16.9503 6.60855L16.7003 6.17554ZM16.7468 6.11626C16.7407 6.13921 16.7254 6.16104 16.7003 6.17553L16.9503 6.60856C17.0932 6.52609 17.1902 6.39346 17.2298 6.24573L16.7468 6.11626ZM16.7414 6.05228C16.751 6.07353 16.7523 6.09605 16.7468 6.11626L17.2298 6.24574C17.2644 6.11656 17.2553 5.97526 17.1969 5.84613L16.7414 6.05228ZM16.7368 6.04222C16.7375 6.04357 16.738 6.04464 16.7384 6.04542L17.1999 5.85299C17.1911 5.83189 17.1809 5.81144 17.1695 5.79174L16.7368 6.04222ZM13.9983 1.2991L16.7366 6.04198L17.1696 5.79198L14.4313 1.0491L13.9983 1.2991ZM13.9933 1.29L13.9936 1.29049L14.4361 1.05771L14.4358 1.05721L13.9933 1.29ZM13.9389 1.25323C13.9631 1.25969 13.9845 1.27518 13.9981 1.29873L14.431 1.04848C14.3485 0.90583 14.2155 0.809601 14.0681 0.770187L13.9389 1.25323ZM6.61166 5.80137L9.14433 10.188L9.57734 9.93803L7.04467 5.55136L6.61166 5.80137ZM13.7128 1.41285L6.70317 5.45986L6.95317 5.89287L13.9628 1.84586L13.7128 1.41285ZM16.587 5.89103L14.0543 1.50435L13.6213 1.75435L16.154 6.14103L16.587 5.89103ZM9.48583 10.2795L16.4955 6.23254L16.2455 5.79953L9.23583 9.84653L9.48583 10.2795Z"
                          fill="#253B95" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.7187 11.3115H0.277716H0V11.5893V15.7467V16.0244H0.277716H1.7187H1.99643V15.7467V11.5893V11.3115H1.7187ZM0.555447 11.867H1.44096V15.4689H0.555447V11.867Z"
                          fill="#253B95" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.44095 12.0401V15.1073L1.44096 15.1073V15.3502L1.68288 15.3817C2.24299 15.4547 2.77775 15.5317 3.27808 15.6037L3.27829 15.6038C5.19009 15.879 6.59399 16.0809 8.03315 15.8366C9.47595 15.5916 10.9211 14.9027 12.892 13.3979L12.9842 13.2721C13.0908 12.9778 13.1523 12.7631 13.1744 12.6133C13.2167 12.3266 13.1355 12.1627 12.9475 12.0933C12.64 11.9797 12.0216 12.2345 11.1823 12.5802L11.1821 12.5803L11.1817 12.5804C10.3061 12.9411 9.18718 13.402 7.95277 13.6456C6.77743 13.8776 5.49246 13.9128 4.20765 13.4725L7.06931 12.0416C7.36224 11.8952 7.3581 11.8576 7.32344 11.5452L7.32155 11.5279L7.32143 11.528C7.28246 11.1761 7.05235 10.7007 6.10962 10.6408C5.32746 10.591 3.96793 10.8411 1.6156 11.783L1.44095 11.853V12.0401ZM1.99641 14.8647V12.2279L1.99641 12.2279C4.15044 11.3789 5.37963 11.1498 6.07491 11.1941C6.61045 11.2282 6.74569 11.4236 6.76861 11.5736L3.86905 13.0234C3.80684 13.0485 3.74967 13.0866 3.70167 13.1356C3.65345 13.1847 3.6149 13.2439 3.59009 13.3113C3.54525 13.433 3.56153 13.5676 3.60565 13.6761C3.62686 13.7284 3.65575 13.7776 3.6877 13.8177C3.73435 13.8762 3.79323 13.9218 3.85777 13.9456C3.88271 13.9548 3.90793 13.961 3.93332 13.9639C5.3569 14.476 6.77199 14.4443 8.05906 14.1902C9.34186 13.9371 10.4921 13.4632 11.3923 13.0924L11.3925 13.0923C11.9406 12.8665 12.3795 12.6858 12.6067 12.6285C12.5841 12.7248 12.546 12.8497 12.4907 13.0068C10.6324 14.4168 9.2775 15.063 7.942 15.2898C6.58734 15.5198 5.21931 15.323 3.35633 15.0548L3.35612 15.0548L3.35532 15.0546C2.94732 14.9959 2.51473 14.9337 1.99641 14.8647Z"
                          fill="#253B95" />
                        <path
                          d="M1.44095 15.1073H1.19095V15.223L1.27918 15.2979L1.44095 15.1073ZM1.44096 15.1073H1.69096V14.9915L1.60273 14.9167L1.44096 15.1073ZM1.44096 15.3502H1.19096V15.5697L1.40865 15.5981L1.44096 15.3502ZM1.68288 15.3817L1.65057 15.6296L1.65058 15.6296L1.68288 15.3817ZM3.27808 15.6037L3.24245 15.8512L3.24697 15.8518L3.27808 15.6037ZM3.27829 15.6038L3.31392 15.3563L3.3094 15.3557L3.27829 15.6038ZM8.03315 15.8366L7.9913 15.5901L7.9913 15.5901L8.03315 15.8366ZM12.892 13.3979L13.0437 13.5967L13.0723 13.5748L13.0936 13.5457L12.892 13.3979ZM12.9842 13.2721L13.1858 13.4199L13.207 13.3909L13.2193 13.3572L12.9842 13.2721ZM13.1744 12.6133L12.927 12.5768L12.927 12.5768L13.1744 12.6133ZM12.9475 12.0933L12.8609 12.3278L12.8609 12.3278L12.9475 12.0933ZM11.1823 12.5802L11.0871 12.349L11.087 12.349L11.1823 12.5802ZM11.1821 12.5803L11.0868 12.3491L11.0866 12.3492L11.1821 12.5803ZM11.1817 12.5804L11.277 12.8116L11.2773 12.8114L11.1817 12.5804ZM7.95277 13.6456L8.00117 13.8909L8.00118 13.8909L7.95277 13.6456ZM4.20765 13.4725L4.09584 13.2489L3.56236 13.5156L4.1266 13.709L4.20765 13.4725ZM7.06931 12.0416L6.95753 11.818L6.95751 11.818L7.06931 12.0416ZM7.32344 11.5452L7.07493 11.5725L7.07497 11.5728L7.32344 11.5452ZM7.32155 11.5279L7.57006 11.5007L7.54276 11.2519L7.29401 11.2795L7.32155 11.5279ZM7.32143 11.528L7.07295 11.5555L7.10047 11.804L7.34897 11.7764L7.32143 11.528ZM6.10962 10.6408L6.09374 10.8902L6.09374 10.8902L6.10962 10.6408ZM1.6156 11.783L1.70854 12.0151L1.70854 12.0151L1.6156 11.783ZM1.44095 11.853L1.34802 11.6209L1.19095 11.6838V11.853H1.44095ZM1.99641 12.2279L2.22947 12.1374L1.74641 12.2279H1.99641ZM1.99641 14.8647H1.74641V15.0836L1.96342 15.1125L1.99641 14.8647ZM1.99641 12.2279L1.76335 12.3184L1.85429 12.5527L2.08809 12.4605L1.99641 12.2279ZM6.07491 11.1941L6.09079 10.9446L6.09078 10.9446L6.07491 11.1941ZM6.76861 11.5736L6.88041 11.7972L7.04323 11.7158L7.01574 11.5358L6.76861 11.5736ZM3.86905 13.0234L3.96288 13.2551L3.97202 13.2514L3.98085 13.247L3.86905 13.0234ZM3.70167 13.1356L3.8801 13.3107L3.8802 13.3106L3.70167 13.1356ZM3.59009 13.3113L3.82468 13.3977L3.82468 13.3977L3.59009 13.3113ZM3.60565 13.6761L3.83727 13.582L3.83724 13.582L3.60565 13.6761ZM3.6877 13.8177L3.88325 13.6619L3.88319 13.6618L3.6877 13.8177ZM3.85777 13.9456L3.77138 14.1802L3.77145 14.1802L3.85777 13.9456ZM3.93332 13.9639L4.01794 13.7287L3.99101 13.719L3.96259 13.7157L3.93332 13.9639ZM8.05906 14.1902L8.01065 13.945L8.01065 13.945L8.05906 14.1902ZM11.3923 13.0924L11.2977 12.861L11.297 12.8613L11.3923 13.0924ZM11.3925 13.0923L11.4871 13.3237L11.4878 13.3235L11.3925 13.0923ZM12.6067 12.6285L12.8501 12.6855L12.9437 12.2857L12.5456 12.3861L12.6067 12.6285ZM12.4907 13.0068L12.6418 13.206L12.7017 13.1606L12.7266 13.0897L12.4907 13.0068ZM7.942 15.2898L7.98385 15.5363L7.942 15.2898ZM3.35633 15.0548L3.39195 14.8073L3.38744 14.8067L3.35633 15.0548ZM3.35612 15.0548L3.32059 15.3023L3.325 15.3028L3.35612 15.0548ZM3.35532 15.0546L3.3197 15.3021L3.31979 15.3021L3.35532 15.0546ZM1.69095 15.1073V12.0401H1.19095V15.1073H1.69095ZM1.60273 14.9167L1.60272 14.9167L1.27918 15.2979L1.27919 15.2979L1.60273 14.9167ZM1.69096 15.3502V15.1073H1.19096V15.3502H1.69096ZM1.71519 15.1338L1.47327 15.1023L1.40865 15.5981L1.65057 15.6296L1.71519 15.1338ZM3.3137 15.3563C2.81356 15.2843 2.2772 15.2071 1.71518 15.1338L1.65058 15.6296C2.20878 15.7024 2.74193 15.7791 3.24246 15.8512L3.3137 15.3563ZM3.3094 15.3557L3.30919 15.3557L3.24697 15.8518L3.24718 15.8518L3.3094 15.3557ZM7.9913 15.5901C6.59805 15.8267 5.23505 15.6329 3.31391 15.3563L3.24267 15.8512C5.14513 16.1251 6.58993 16.3352 8.07499 16.0831L7.9913 15.5901ZM12.7403 13.1992C10.7864 14.6909 9.37884 15.3545 7.9913 15.5901L8.07499 16.0831C9.57307 15.8287 11.0557 15.1144 13.0437 13.5967L12.7403 13.1992ZM12.7825 13.1243L12.6903 13.2502L13.0936 13.5457L13.1858 13.4199L12.7825 13.1243ZM12.927 12.5768C12.9088 12.7008 12.8545 12.896 12.7491 13.187L13.2193 13.3572C13.3271 13.0595 13.3958 12.8254 13.4217 12.6498L12.927 12.5768ZM12.8609 12.3278C12.9008 12.3425 12.912 12.3581 12.9193 12.3745C12.9308 12.4 12.9444 12.4591 12.927 12.5768L13.4217 12.6498C13.4466 12.4808 13.4408 12.3146 13.3752 12.1691C13.3056 12.0145 13.1822 11.9134 13.0341 11.8588L12.8609 12.3278ZM11.2776 12.8113C11.701 12.6369 12.0537 12.4919 12.3386 12.4032C12.4803 12.3591 12.5962 12.332 12.6889 12.3212C12.7837 12.3101 12.8357 12.3185 12.8609 12.3278L13.0341 11.8588C12.9055 11.8113 12.7649 11.8089 12.631 11.8245C12.4951 11.8404 12.3462 11.8772 12.19 11.9258C11.879 12.0226 11.5029 12.1777 11.0871 12.349L11.2776 12.8113ZM11.2774 12.8114L11.2776 12.8113L11.087 12.349L11.0868 12.3491L11.2774 12.8114ZM11.2773 12.8114L11.2776 12.8113L11.0866 12.3492L11.0862 12.3494L11.2773 12.8114ZM8.00118 13.8909C9.26298 13.6419 10.4032 13.1715 11.277 12.8116L11.0865 12.3492C10.209 12.7107 9.11139 13.1621 7.90436 13.4004L8.00118 13.8909ZM4.1266 13.709C5.46519 14.1677 6.7973 14.1285 8.00117 13.8909L7.90436 13.4004C6.75756 13.6267 5.51974 13.6578 4.28869 13.236L4.1266 13.709ZM6.95751 11.818L4.09584 13.2489L4.31945 13.6961L7.18111 12.2652L6.95751 11.818ZM7.07497 11.5728C7.08414 11.6554 7.08909 11.7025 7.08957 11.7374C7.09001 11.7695 7.08562 11.765 7.0928 11.7497C7.10112 11.7319 7.11035 11.7297 7.09136 11.7434C7.0689 11.7595 7.03021 11.7817 6.95753 11.818L7.18109 12.2653C7.25488 12.2284 7.32551 12.1909 7.38359 12.1491C7.44512 12.1048 7.50607 12.0462 7.54564 11.9616C7.58407 11.8795 7.59045 11.7979 7.58952 11.7305C7.58863 11.6659 7.58007 11.5911 7.57192 11.5176L7.07497 11.5728ZM7.07304 11.5552L7.07493 11.5725L7.57195 11.5179L7.57006 11.5007L7.07304 11.5552ZM7.34897 11.7764L7.34909 11.7764L7.29401 11.2795L7.29389 11.2795L7.34897 11.7764ZM6.09374 10.8902C6.52531 10.9177 6.75667 11.0375 6.88273 11.1566C7.00845 11.2754 7.05801 11.4205 7.07295 11.5555L7.56991 11.5004C7.54589 11.2835 7.46091 11.015 7.22614 10.7932C6.99172 10.5717 6.63666 10.4238 6.12549 10.3913L6.09374 10.8902ZM1.70854 12.0151C4.054 11.0759 5.36998 10.8442 6.09374 10.8902L6.12549 10.3913C5.28495 10.3378 3.88186 10.6063 1.52267 11.5509L1.70854 12.0151ZM1.53388 12.085L1.70854 12.0151L1.52267 11.5509L1.34802 11.6209L1.53388 12.085ZM1.69095 12.0401V11.853H1.19095V12.0401H1.69095ZM1.74641 12.2279V14.8647H2.24641V12.2279H1.74641ZM2.22947 12.1375L2.22947 12.1374L1.76335 12.3184L1.76335 12.3184L2.22947 12.1375ZM6.09078 10.9446C5.33702 10.8966 4.064 11.1442 1.90473 11.9953L2.08809 12.4605C4.23687 11.6135 5.42225 11.403 6.05904 11.4436L6.09078 10.9446ZM7.01574 11.5358C6.99458 11.3973 6.92007 11.2484 6.75648 11.1349C6.60151 11.0274 6.38337 10.9632 6.09079 10.9446L6.05903 11.4436C6.30199 11.459 6.41924 11.5095 6.47151 11.5458C6.51515 11.576 6.51972 11.5998 6.52147 11.6113L7.01574 11.5358ZM3.98085 13.247L6.88041 11.7972L6.6568 11.35L3.75725 12.7998L3.98085 13.247ZM3.8802 13.3106C3.90408 13.2862 3.93238 13.2674 3.96288 13.2551L3.77522 12.7916C3.6813 12.8297 3.59527 12.887 3.52314 12.9606L3.8802 13.3106ZM3.82468 13.3977C3.83678 13.3649 3.85568 13.3356 3.8801 13.3107L3.52324 12.9605C3.45122 13.0338 3.39302 13.123 3.3555 13.2249L3.82468 13.3977ZM3.83724 13.582C3.80987 13.5146 3.80684 13.4461 3.82468 13.3977L3.3555 13.2249C3.28367 13.4198 3.31319 13.6206 3.37406 13.7703L3.83724 13.582ZM3.88319 13.6618C3.86674 13.6412 3.84981 13.6129 3.83727 13.582L3.37402 13.7702C3.40392 13.8438 3.44476 13.914 3.49221 13.9735L3.88319 13.6618ZM3.94416 13.711C3.92969 13.7057 3.90658 13.6912 3.88325 13.6619L3.49215 13.9734C3.56213 14.0613 3.65677 14.138 3.77138 14.1802L3.94416 13.711ZM3.96259 13.7157C3.95804 13.7151 3.95194 13.7138 3.94409 13.711L3.77145 14.1802C3.81348 14.1957 3.85781 14.2068 3.90406 14.2122L3.96259 13.7157ZM8.01065 13.945C6.75342 14.1931 5.38679 14.2211 4.01794 13.7287L3.84871 14.1992C5.327 14.7309 6.79056 14.6954 8.10747 14.4355L8.01065 13.945ZM11.297 12.8613C10.3952 13.2328 9.26615 13.6972 8.01065 13.945L8.10747 14.4355C9.41758 14.1769 10.5891 13.6937 11.4875 13.3236L11.297 12.8613ZM11.2979 12.8609L11.2977 12.861L11.4869 13.3238L11.4871 13.3237L11.2979 12.8609ZM12.5456 12.3861C12.2959 12.4491 11.8342 12.64 11.2973 12.8612L11.4878 13.3235C12.0471 13.0931 12.4631 12.9225 12.6678 12.8709L12.5456 12.3861ZM12.7266 13.0897C12.7831 12.9288 12.8246 12.7944 12.8501 12.6855L12.3633 12.5715C12.3437 12.6553 12.3088 12.7706 12.2549 12.9239L12.7266 13.0897ZM7.98385 15.5363C9.37475 15.3001 10.7671 14.6284 12.6418 13.206L12.3396 12.8077C10.4976 14.2052 9.18024 14.826 7.90016 15.0433L7.98385 15.5363ZM3.3207 15.3022C5.17336 15.5689 6.58299 15.7741 7.98385 15.5363L7.90016 15.0433C6.59169 15.2655 5.26525 15.077 3.39195 14.8073L3.3207 15.3022ZM3.325 15.3028L3.32521 15.3028L3.38744 14.8067L3.38723 14.8067L3.325 15.3028ZM3.31979 15.3021L3.32059 15.3022L3.39164 14.8073L3.39085 14.8072L3.31979 15.3021ZM1.96342 15.1125C2.48028 15.1813 2.91169 15.2434 3.3197 15.3021L3.39094 14.8072C2.98296 14.7485 2.54918 14.686 2.0294 14.6168L1.96342 15.1125Z"
                          fill="#253B95" />
                        <path
                          d="M11.7089 7.58351L10.7671 5.98878C10.6145 5.73029 10.9092 5.43968 11.1655 5.596L12.419 6.36051C12.6753 6.51682 12.9703 6.22657 12.8176 5.96808C12.5016 5.43297 12.1155 4.77921 11.8123 4.26582"
                          stroke="#253B95" stroke-width="0.562237" />
                        <rect x="10.5467" y="7.10352" width="3.42069" height="0.342069"
                          transform="rotate(-30.5656 10.5467 7.10352)" fill="#253B95" />
                        <rect x="10.1454" y="6.42383" width="3.42069" height="0.342069"
                          transform="rotate(-30.5656 10.1454 6.42383)" fill="#253B95" />
                      </svg>
                      <svg class="w-4 h-4 mr-3" v-if="payment.payment_method == 'transfer'" viewBox="0 0 16 16"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.15625 5.6875H11.3125" stroke="#003283" stroke-width="0.9375" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M9.4375 3.8125L11.3125 5.6875L9.4375 7.5625" stroke="#003283" stroke-width="0.9375"
                          stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.90625 10.375H4.75" stroke="#003283" stroke-width="0.9375" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M6.625 12.25L4.75 10.375L6.625 8.5" stroke="#003283" stroke-width="0.9375"
                          stroke-linecap="round" stroke-linejoin="round" />
                        <rect x="1" y="1" width="14.0625" height="14.0625" rx="1.875" stroke="#003283"
                          stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <svg class="w-4 h-4 mr-3" v-if="payment.payment_method == 'cash'" viewBox="0 0 17 17" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M3.55682 7.73269C3.69803 7.73269 3.8125 7.84716 3.8125 7.98837C3.8125 8.12958 3.69803 8.24405 3.55682 8.24405C3.41561 8.24405 3.30114 8.12958 3.30114 7.98837C3.30114 7.84716 3.41561 7.73269 3.55682 7.73269"
                          stroke="#003283" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M13.7841 12.8469C13.9253 12.8469 14.0398 12.9614 14.0398 13.1026C14.0398 13.2438 13.9253 13.3583 13.7841 13.3583C13.6429 13.3583 13.5284 13.2438 13.5284 13.1026C13.5284 12.9614 13.6429 12.8469 13.7841 12.8469"
                          stroke="#003283" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round" />
                        <rect x="1" y="5.43164" width="15.3409" height="10.2273" rx="1.02273" stroke="#003283"
                          stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round" />
                        <circle cx="8.67045" cy="10.5455" r="2.04545" fill="#B4E6FF" stroke="#003283" stroke-width="0.9"
                          stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2.02273 3.38681H15.3182" stroke="#003283" stroke-width="0.9" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M4.06818 1.34091H13.2727" stroke="#003283" stroke-width="0.9" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>

                      <div class="text-xs">
                        {{ bankNameType(payment.payment_method) }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="text-center py-4 text-xs capitalize text-accentDark">
                  {{ payment.sale_agent }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-xs font-medium p-4" colspan="8">
                  <trac-center-data>
                    <div class="h-40 flex items-center text-lg text-gray-600">
                      No data
                    </div>
                  </trac-center-data>
                </td>
              </tr>
            </tbody>
            <tbody v-if="search.length > 0 && allEmployeeSales.length > 0">
              <tr>
                <td class="text-xs font-medium p-4" colspan="8">
                  <trac-center-data>
                    <div class="h-40 flex items-center text-lg text-gray-600">
                      No match Found
                    </div>
                  </trac-center-data>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


    </div>
  </main>
</template>

<script>
import { eventBus } from "./../../main";
import moment from "moment";
import ClickOutside from "vue-click-outside";


export default {
  directives: {
    ClickOutside,
  },
  data() {
    return {
      isLoading: false,
      allEmployeeSales: null,
      user: null,
      moment,
      userSaleSummaryDetails: null,
      salesHistory: [],
      allSalesHistory: [],
      selectedPaymentMethods: [],
      confirmOp: false,
      search: '',
      storeData: [],
      paymentAll: true,
      selectedStores: [],
      allPaymentMethods: true,
      active: false,
      noUserSaleSummaryDetails: false,
      open: false,
      paymentStore: false,
      paymentDropdownData: false,
      time: "today",
      filterFlag: "store",
      paymentMethods: [
        {
          _id: "cash",
          name: "Cash",
        },
        {
          _id: "pos",
          name: "POS",
        },
        {
          _id: "online",
          name: "Online",
        },
        {
          _id: "own_bank_account",
          name: "Bank Transfer",
        },
        {
          _id: "fixed_account",
          name: "Bank transfer (Fixed)",
        },
        {
          _id: "bank_transfer",
          name: "Bank transfer (Dynamic)",
        },
      ],
    };
  },
  created() {
    this.getUserDetails();
    if (!this.user) {
      this.$router.replace({ name: 'UserRoles' });
    }
    this.getEmployeeSalesData();
    this.getEmployeeSalesSummary();
    this.fetchAllStores();
  },
  computed: {
    getAllCsv() {
      let u = this.storeData.map((x, i) => {
        let k = {};
        k.name = x.name;
        k._id = x._id;
        return k;
      });

      return u;
    },
    allHistory() {
      return this.salesHistory.filter((x) => {
        if (x.customer_name) {
          return (x.customer_name || "")
            .toLowerCase()
            .includes(this.search.toLowerCase());
        } else {
          return (x.receipt_number || "")
            .toLowerCase()
            .includes(this.search.toLowerCase());
        }
      });
    },
    sortbyOtherFilterMethods() {
      let allData = this.salesHistory || [];
      const allFilteredStoreName = allData.filter((sale) => {
        return (
          (this.selectedStores.includes(sale.store_id) &&
            this.filterFlag === "store") ||
          (this.selectedPaymentMethods.includes(sale.payment_method) &&
            this.filterFlag === "payment")
        );
      });

      return allFilteredStoreName;
    },
  },
  methods: {
    paymentDrop() {
      this.paymentStore = false;
    },
    dismissPaymentDropdown() {
      this.paymentDropdownData = false;
    },
    dismissdateFilterDropdown() {
      this.active = false;
    },
    bankNameType(x) {
      if (x == "bank_transfer") {
        return "Bank Transfer (Dynamic)";
      } else if (x == "fixed_account") {
        return "Bank Transfer (Fixed)";
      } else if (x == "own_bank_account") {
        return "Own Bank Account";
      } else {
        return x;
      }
    },
    getUserDetails() {
      this.user = this.$store.getters['GET_EMPLOYEE_DATA'];
    },
    sendtoEmployee() {
      this.$store.commit("setUserDetails", this.user);
      this.$router.push({ name: "EditEmployeeDetailsUser" });
    },
    async fetchAllStores() {
      await this.$store.dispatch("FETCH_ALL_STORES");
      const res = this.$store.getters["GET_ALL_STORES"];
      if (res.status) {
        this.storeData = [...res.data] || {};
        this.selectedStores = this.storeData.map((store) => store._id);
      }
    },
    async getEmployeeSalesData() {
      const payload = {
        startdate: '',
        endDate: '',
        employeeId: this.user._id,
      };
      const res = await this.$store.dispatch('FETCH_EMPLOYEE_SALES_DATA', payload);
      if (res.status) {
        this.allEmployeeSales = res.data || [];
        this.salesHistory = this.allEmployeeSales;
        this.allSalesHistory = this.allEmployeeSales;
      } else {
        eventBus.$emit('trac-alert', { message: res.message });
      }
    },
    async getEmployeeSalesSummary() {
      const payload = {
        employeeId: this.user._id,
      };
      const res = await this.$store.dispatch('FETCH_EMPLOYEE_SALES_SUMMARY', payload);
      if (res.status) {
        this.userSaleSummaryDetails = res.data || {};
      } else {
        this.noUserSaleSummaryDetails = true;
        eventBus.$emit('trac-alert', { message: res.message });
      }
    },
    async updateOps(op) {
      this.isLoading = true;

      const payload = {
        ops: op,
        users: [
          {
            id: this.user._id,
          }
        ],
      };
      let res = await this.$store.dispatch("UPDATE_USER_OPS", payload);

      if (res.status) {
        if (op === 'active') {
          this.user.active = true;
        } else if (op === 'deactivated') {
          this.user.active = false;
        }

        if (op === 'deleted') {
          eventBus.$emit("trac-alert", { message: this.user.first_name + ' deleted successfully.' });
          this.$router.replace({ name: 'UserSettings'});
        } else {
          eventBus.$emit("trac-alert", { message: res.message });
        }
      }
      this.isLoading = false;
    },
  },
  watch: {
    custom: {
      handler(x, y) {
        this.time = "custom";
        let payload = {};
        payload.startDate = this.moment(this.custom[0]).format("YYYY-MM-DD");
        payload.endDate = this.moment(this.custom[1]).format("YYYY-MM-DD");
        this.salesHistory = [...this.allSalesHistory].filter((x) => {
          return (
            this.moment(x.created_at).format("YYYY-MM-DD") >=
            payload.startDate &&
            this.moment(x.created_at).format("YYYY-MM-DD") <= payload.endDate
          );
        });
        // this.$refs.datepicker.closePopup()
        // this.active = false
      },
    },
    allPaymentMethods: {
      immediate: true,
      handler(x) {
        if (x) {
          this.paymentMethods.forEach((paymentMethod) => {
            if (!this.selectedPaymentMethods.includes(paymentMethod._id)) {
              this.selectedPaymentMethods.push(paymentMethod._id);
            } else {
              let index = this.selectedPaymentMethods.indexOf(
                paymentMethod._id
              );
              this.selectedPaymentMethods.splice(index, 1);
              this.selectedPaymentMethods.push(paymentMethod._id);
            }
          });
        } else {
          this.selectedPaymentMethods = [];
        }
      },
    },
    paymentAll: {
      immediate: true,
      handler(x) {
        if (x) {
          this.getAllCsv.forEach((store) => {
            if (!this.selectedStores.includes(store)) {
              this.selectedStores.push(store._id);
            } else {
              let index = this.selectedStores.indexOf(store);
              this.selectedStores.splice(index, 1);
              this.selectedStores.push(store._id);
            }
          });
        } else {
          this.selectedStores = [];
        }
      },
    },
    time: {
      immediate: true,
      handler(x, y) {
        let payload = {};
        switch (x) {
          case "today":
            this.current = `Today's`;
            payload.startDate = this.moment().format("YYYY-MM-DD");
            payload.endDate = this.moment().format("YYYY-MM-DD");
            this.salesHistory = [...this.allSalesHistory].filter((x) => {
              return (
                this.moment(x.created_at).format("YYYY-MM-DD") ===
                payload.startDate
              );
            });

            break;
          case "currentMonth":
            this.current = `This Month's`;
            payload.startDate = this.moment()
              .startOf("month")
              .format("YYYY-MM-DD");
            payload.endDate = this.moment().format("YYYY-MM-DD");
            this.salesHistory = [...this.allSalesHistory].filter((x) => {
              let date = this.moment(x.created_at).format("YYYY-MM-DD");
              return date >= payload.startDate && date <= payload.endDate;
            });
            break;
          case "lastMonth":
            this.current = `Last Month's`;
            payload.startDate = this.moment()
              .subtract(1, "months")
              .startOf("month")
              .format("YYYY-MM-DD");
            payload.endDate = this.moment()
              .subtract(1, "months")
              .endOf("month")
              .format("YYYY-MM-DD");
            this.salesHistory = [...this.allSalesHistory].filter((x) => {
              let date = this.moment(x.created_at).format("YYYY-MM-DD");
              return date >= payload.startDate && date <= payload.endDate;
            });
            break;
          case "custom":
            this.current = "Total";
            payload.startDate = this.moment(this.custom[0]).format(
              "YYYY-MM-DD"
            );
            payload.endDate = this.moment(this.custom[1]).format("YYYY-MM-DD");
            this.salesHistory = [...this.allSalesHistory].filter((x) => {
              return (
                this.moment(x.created_at).format("YYYY-MM-DD") >=
                payload.startDate &&
                this.moment(x.created_at).format("YYYY-MM-DD") <=
                payload.endDate
              );
            });
            break;
          default:
            break;
        }
      },
    },
  }
};
</script>